<template>
  

   <div class=" has-text-white scrollableY">
           <div class="top40 is-size-5 container"> 
                <div class="is-size-1 has-text-coolGreen"><b>About Miimu</b></div>
                <br>

                <div>Welcome to your new <b>Internet Brain(c)</b>. Miimi makes it easy to stay organized online. We help you save time searching for lost content — and reduce the stress of managing too many open tabs.
                </div>

                <div class="is-size-4 top20 has-text-coolGreen"><b>The Origin of Miimu</b></div>

                <div class="top10"><p>Miimu started with a conversation on a beach in Mexico. A husband and wife wondered if there was a way to organize information from the apps and online services they used, all in one place.</p>

                <p class="top20">That conversation turned into a lunch date with an app engineer, and that lunch date turned into a prototype journey that exploded into research and development, millions of lines of code, and one of the longest beta testing periods in human history.</p>

                <p class="top20">Through it all, a rock-solid foundation for Miimu was created. </p>
                </div>

                <div class="is-size-4 top30 has-text-coolGreen"><b>What is Miimu?</b></div>

                <div class="top10">Our mission is simple: <b>capture</b> miimus [smart links], <b>bundle</b> them together, and <b>share</b> your creations with the world. Then, collaborate with other Miimu users to create an interconnected web of cool, useful bundles. There’s no shortage of possibilities for keeping those digital thoughts together.
                </div>

                <div class="is-size-4 top30 has-text-coolGreen"><b>Get Started With Miimu</b></div>

                <div class="top10">Ready to take back control of your Internet use? <b>We’ll show you the way</b>. <u class="handCursor" @click="$router.push('/register')"><b>Sign up</b></u> and create your first bundle today.
                </div>


            </div>
            <footerdiv class="top160"></footerdiv>
     </div>
    



</template>


<script>

import Footerdiv from '../components/Footer.vue'

export default{
  components: {Footerdiv},

  data: function(){
    return {
      
    } 
  }

}

</script>

